import type { Input } from '@builder.io/sdk';

export const formFields = [
  {
    name: 'type',
    type: 'string',
    enum: ['date', 'number', 'text', 'textarea', 'select'],
    defaultValue: 'date',
  },
  {
    name: 'variant',
    type: 'string',
    enum: ['standard', 'outlined'],
    defaultValue: 'standard',
  },
  {
    name: 'fieldName',
    type: 'string',
  },
  {
    name: 'label',
    type: 'string',
  },
  {
    name: 'helperText',
    type: 'string',
  },
  {
    name: 'required',
    type: 'boolean',
    defaultValue: false,
  },
] as const satisfies DeepReadonly<Input[]>;

export type FormProps = GenerateBuilder<typeof formFields>;

export const formConfig = {
  name: 'HCI Form',
  inputs: formFields,
};

export default formFields;
